/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';

import Button from '../../../../../../../components/Button';
import Loading from '../../../../../../../components/Loading';

import Modal from '../../../../../../../components/Modal';

import { Container, Content, ActionSaveModal } from './styles';

interface ModalDTO {
  loadModalProp: boolean;
  indexInvoice: number;
  removeInvoice: (index: number) => void;
  closeModalConfirmationOfExclusionInvoiceProp: () => void;
}

const ModalConfirmationOfExclusionInvoice: React.FC<ModalDTO> = ({
  loadModalProp = false,
  indexInvoice,
  closeModalConfirmationOfExclusionInvoiceProp,
  removeInvoice,
}) => {
  return (
    <Modal visibleProp={loadModalProp}>
      <Container>
        <h1>Deseja excluir esta parcela?</h1>
        <Content>
          <ActionSaveModal>
            <Button
              type="button"
              onClick={() => {
                removeInvoice(indexInvoice);
                closeModalConfirmationOfExclusionInvoiceProp();
              }}
            >
              Sim
            </Button>
            <Button
              type="button"
              onClick={() => {
                closeModalConfirmationOfExclusionInvoiceProp();
              }}
            >
              Não
            </Button>
          </ActionSaveModal>
        </Content>
      </Container>
    </Modal>
  );
};

export default ModalConfirmationOfExclusionInvoice;
